import { defaultConfig as b, mergeConfigs as O, defineConfig as E, ChakraProvider as k, EnvironmentProvider as z, Box as L } from "@chakra-ui/react";
import { baseThemeConfig as D, createTheme as $, frontEndConfigOverrides as X, ColorModeProvider as Y } from "../themes/index.js";
import { jsx as r, Fragment as A } from "react/jsx-runtime";
import u from "react";
import { CacheProvider as H } from "@emotion/react";
import I from "@emotion/cache";
const h = /(-?[\d.]+)rem/g;
function q(e) {
  return e.includes("rem") ? e.replace(h, (t, o) => `calc(${o}rem * var(--widget-rem-scale, 1))`) : e;
}
function m(e) {
  const t = {};
  for (const [o, n] of Object.entries(e)) {
    if (n == null || typeof n != "object") continue;
    if ("value" in n) {
      const s = n.value;
      typeof s == "string" && h.test(s) && (h.lastIndex = 0, t[o] = { value: q(s) });
      continue;
    }
    const i = m(n);
    Object.keys(i).length > 0 && (t[o] = i);
  }
  return t;
}
function Z(e) {
  const t = {};
  for (const [o, n] of Object.entries(e)) {
    if (!(n != null && n.value) || typeof n.value != "object") continue;
    const i = {};
    let s = !1;
    for (const [c, f] of Object.entries(n.value))
      typeof f == "string" && h.test(f) && (h.lastIndex = 0, i[c] = q(f), s = !0);
    s && (t[o] = { value: { ...n.value, ...i } });
  }
  return t;
}
function ee() {
  var o, n;
  const e = (o = b.theme) == null ? void 0 : o.tokens, t = (n = b.theme) == null ? void 0 : n.textStyles;
  return {
    tokens: e ? {
      ...e.spacing ? { spacing: m(e.spacing) } : {},
      ...e.fontSizes ? { fontSizes: m(e.fontSizes) } : {},
      ...e.sizes ? { sizes: m(e.sizes) } : {},
      ...e.radii ? { radii: m(e.radii) } : {}
    } : {},
    textStyles: t ? Z(t) : {}
  };
}
function B(e) {
  const t = parseFloat(
    getComputedStyle(document.documentElement).fontSize
  );
  if (!t || t <= 0) return 1;
  const o = 16 / t;
  return Math.abs(o - 1) > 0.01 && e.style.setProperty("--widget-rem-scale", o.toFixed(4)), o;
}
const d = ":host", g = ee();
var j, W;
const P = (W = (j = D.theme) == null ? void 0 : j.tokens) == null ? void 0 : W.radii, te = P ? m(P) : {};
function K(e) {
  var n;
  const t = O(D, E(X));
  if (e === "document")
    return t;
  const o = E({
    cssVarsRoot: d,
    conditions: {
      // Widgets are always light mode for consistent branding
      light: `${d} [data-theme=light] &, ${d} .light &`,
      // Dark mode condition defined but never used (widgets force light mode)
      dark: `${d} [data-theme=dark] &, ${d} .dark &`
    },
    preflight: {
      scope: d
    },
    // Widgets should have minimal global styles to avoid conflicts with host pages
    globalCss: {
      [d]: {
        ...(n = b.globalCss) == null ? void 0 : n.html,
        // Force light color scheme to prevent browser dark mode overrides
        colorScheme: "light"
      }
    },
    // Override rem-based tokens and textStyles with calc() expressions
    // that reference --widget-rem-scale for host-page font-size compensation
    theme: {
      tokens: {
        ...g.tokens,
        // Merge scaled base-theme radii on top of scaled default radii
        radii: { ...g.tokens.radii, ...te }
      },
      textStyles: g.textStyles
    }
  });
  return O(t, o);
}
const N = $(K("document")), C = $(K("shadow")), ve = N, be = C, Ce = ({ children: e, theme: t }) => /* @__PURE__ */ r(k, { value: N, children: /* @__PURE__ */ r(Y, { ...t ? { forcedTheme: t, enableSystem: !1 } : { enableSystem: !0, defaultTheme: "light" }, children: /* @__PURE__ */ r("div", { "data-theme": t ?? "auto", children: e }) }) }), U = u.createContext(null), oe = ({ value: e, children: t }) => e ? /* @__PURE__ */ r(U.Provider, { value: e, children: t }) : /* @__PURE__ */ r(A, { children: t }), ne = () => u.useContext(U), Se = ({ children: e }) => {
  const t = ne();
  return t ? /* @__PURE__ */ r(H, { value: t.cache, children: /* @__PURE__ */ r(z, { value: () => t.shadowRoot, children: /* @__PURE__ */ r(k, { value: t.system, children: /* @__PURE__ */ r(L, { "data-theme": t.forcedTheme, className: t.forcedTheme, fontFamily: "body", children: e }) }) }) }) : /* @__PURE__ */ r(A, { children: e });
}, F = "kuow-widget-overlay-host", R = "data-kuow-widget-overlay-portal";
let a = null;
const V = () => {
  if (a != null && a.host.isConnected)
    return a;
  if (typeof document > "u" || !document.body)
    return null;
  if (a)
    return document.body.appendChild(a.host), a;
  const e = re(), t = e.shadowRoot ?? e.attachShadow({ mode: "open" }), o = se(t);
  return ce(e), a = { host: e, shadowRoot: t, portalContainer: o }, a;
}, re = () => {
  const e = document.getElementById(F);
  if (e)
    return e;
  const t = document.createElement("div");
  return t.id = F, t.setAttribute("data-kuow-widget-overlay-host", ""), document.body.appendChild(t), t;
}, se = (e) => {
  const t = e.querySelector(`[${R}]`);
  if (t instanceof HTMLDivElement)
    return t;
  const o = document.createElement("div");
  return o.setAttribute(R, ""), e.appendChild(o), o;
}, ce = (e) => {
  e.style.position = "relative", e.style.zIndex = "2147483647", e.style.fontFamily = "var(--chakra-fonts-body)", e.style.colorScheme = "light", B(e);
};
let y = null, T = null;
const ie = (e) => (y && T === e || (T = e, y = I({
  key: "kuow-widget-overlay",
  container: e,
  prepend: !1,
  speedy: !1
})), y), we = ({
  children: e,
  shadowRoot: t,
  system: o,
  layout: n = "fit-content",
  center: i = !0
}) => {
  const s = "light", c = u.useMemo(() => V(), []), f = u.useMemo(() => c ? { current: c.portalContainer } : null, [c]), x = u.useMemo(
    () => c ? ie(c.shadowRoot) : null,
    [c]
  ), G = u.useMemo(() => I({
    key: "kuow-widget",
    container: t,
    prepend: !1,
    speedy: !0
    // set to false to debug the CSS
  }), [t]);
  return u.useEffect(() => {
    const l = t.host;
    if (!l) return;
    const J = l.style.fontFamily, Q = l.style.colorScheme;
    return l.style.fontFamily = "var(--chakra-fonts-body)", l.style.colorScheme = "light", B(l), () => {
      l.style.fontFamily = J, l.style.colorScheme = Q;
    };
  }, [t]), /* @__PURE__ */ r(z, { value: () => t, children: /* @__PURE__ */ r(H, { value: G, children: /* @__PURE__ */ r(k, { value: o ?? C, children: /* @__PURE__ */ r(
    oe,
    {
      value: c && f && x ? {
        portalContainerRef: f,
        cache: x,
        system: o ?? C,
        forcedTheme: s,
        shadowRoot: c.shadowRoot
      } : null,
      children: /* @__PURE__ */ r(
        L,
        {
          "data-theme": s,
          className: s,
          fontFamily: "body",
          display: "block",
          w: n === "full" ? "full" : "fit-content",
          maxW: "100%",
          mx: i ? "auto" : void 0,
          children: e
        }
      )
    }
  ) }) }) });
}, ae = "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500;1,600;1,700;1,800&display=fallback";
function v(e) {
  if (typeof document > "u") return;
  const t = document.head;
  if (!t) return;
  const n = Object.entries(e).map(([s, c]) => `[${s}="${c}"]`).join("");
  if (t.querySelector(n)) return;
  const i = document.createElement("link");
  Object.entries(e).forEach(([s, c]) => {
    i.setAttribute(s, c);
  }), t.appendChild(i);
}
function ke() {
  v({ rel: "preconnect", href: "https://fonts.googleapis.com" }), v({ rel: "preconnect", href: "https://fonts.gstatic.com", crossorigin: "" }), v({ rel: "stylesheet", href: ae });
}
const _ = /* @__PURE__ */ new Set(), S = /* @__PURE__ */ new Set();
let p = null, w = !1;
function le() {
  for (const e of S)
    if (!e.target.isConnected) {
      S.delete(e);
      try {
        e.root.unmount();
      } catch (t) {
        console.error("KUOW widget unmount error", t);
      }
    }
}
function de() {
  w = !1, le(), V();
  for (const e of _)
    try {
      e();
    } catch (t) {
      console.error("KUOW widget re-mount error", t);
    }
}
function M() {
  w || (w = !0, requestAnimationFrame(de));
}
function ue() {
  if (p || typeof document > "u") return;
  const e = () => {
    !document.body || p || (p = new MutationObserver(M), p.observe(document.body, { childList: !0, subtree: !0 }));
  };
  document.body ? e() : document.addEventListener("DOMContentLoaded", e, { once: !0 }), window.addEventListener("pageshow", (t) => {
    t.persisted && M();
  });
}
function xe(e) {
  typeof window > "u" || (_.add(e), ue(), document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", e, { once: !0 }) : e());
}
function Oe(e, t) {
  S.add({ target: e, root: t });
}
export {
  we as ShadowDomWidgetProvider,
  Se as WidgetOverlayPortal,
  oe as WidgetOverlayProvider,
  Ce as WidgetProvider,
  ke as ensureFrontEndFontsLoaded,
  C as frontEndShadowTheme,
  N as frontEndTheme,
  ee as getScaledDefaultTokens,
  V as getSharedOverlayHost,
  Oe as registerRoot,
  m as scaleRemTokens,
  ne as useWidgetOverlay,
  xe as watchForRemount,
  be as widgetShadowTheme,
  ve as widgetTheme
};
